import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=3aaa4b0e&"
import script from "./Documents.vue?vue&type=script&lang=js&"
export * from "./Documents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PROJETS\\VITISSIA\\2024\\vitissiapro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aaa4b0e')) {
      api.createRecord('3aaa4b0e', component.options)
    } else {
      api.reload('3aaa4b0e', component.options)
    }
    module.hot.accept("./Documents.vue?vue&type=template&id=3aaa4b0e&", function () {
      api.rerender('3aaa4b0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/Documents.vue"
export default component.exports